import { Globe } from '@zappyrent/hundop';
import { sortBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import {
  StyledLanguageNav,
  StyledLanguageNavButton,
  StyledLanguageNavContent,
  StyledLanguageNavList,
  StyledLanguageNavListButton,
  StyledLanguageNavListItem,
} from './LanguageSwitch.styles';

const LanguageSwitch = (): JSX.Element => {
  const navigate = useNavigate();
  const { locale } = useParams();
  const { i18n, t } = useTranslation(['a11y']);
  const [sortedLanguages, setSortedLanguages] = useState([
    {
      language: 'it',
      title: 'Italiano',
    },
    {
      language: 'en',
      title: 'English',
    },
  ]);
  const [activeLanguage, setActiveLanguage] = useState<string>(locale!);
  const [dropdownVisibile, setDropdownVisibile] = useState<boolean>(false);

  useEffect(() => {
    setSortedLanguages(
      sortBy(sortedLanguages, ({ language }) =>
        language === activeLanguage ? 0 : 1,
      ),
    );
  }, [activeLanguage]);

  const handleOnClick = (language: string) => {
    const currentLanguage = window.location.pathname.split('/')[1];
    const targetUrl = `${window.location.pathname.replace(
      `/${currentLanguage}`,
      `/${language}`,
    )}${window.location.search}`;

    i18n.changeLanguage(language);
    navigate(targetUrl, { replace: true });
    setActiveLanguage(language);
  };

  return (
    <StyledLanguageNav
      aria-label={t('a11y:toggleLanguageMenu')}
      role="menubar"
      onMouseEnter={() => setDropdownVisibile(true)}
      onMouseLeave={() => setDropdownVisibile(false)}
    >
      <StyledLanguageNavButton
        role="menuitem"
        aria-haspopup="true"
        aria-expanded={dropdownVisibile}
      >
        <Globe /> <span>{activeLanguage}</span>
      </StyledLanguageNavButton>
      <StyledLanguageNavContent aria-hidden={!dropdownVisibile}>
        <StyledLanguageNavList>
          {sortedLanguages.map(item => {
            const { language, title } = item;

            return (
              <StyledLanguageNavListItem key={title}>
                <StyledLanguageNavListButton
                  role="menuitem"
                  title={title}
                  onClick={() => handleOnClick(language)}
                >
                  {language}
                </StyledLanguageNavListButton>
              </StyledLanguageNavListItem>
            );
          })}
        </StyledLanguageNavList>
      </StyledLanguageNavContent>
    </StyledLanguageNav>
  );
};

export default LanguageSwitch;
